import { render, staticRenderFns } from "./form_view.vue?vue&type=template&id=63d5d2ca&"
import script from "./form_view.vue?vue&type=script&lang=js&"
export * from "./form_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports